import React, { useEffect, useState } from "react";
import axios from "axios";

const TodaysThought = ({ sessionId }) => {
  const [todayThought, setTodayThought] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!sessionId) {
      setIsLoading(false);
      return;
    }

    const fetchTodaysThought = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/thoughts/getThoughts/${sessionId}`
        );

        // ✅ handle both response styles
        const thoughts = Array.isArray(res.data)
          ? res.data
          : res.data?.data;

        if (!Array.isArray(thoughts)) return;

        const today = new Date().toISOString().split("T")[0];

        const thoughtForToday = thoughts.find((t) => {
          if (t.isToday) return true;

          if (t.createdAt) {
            const thoughtDate = new Date(t.createdAt)
              .toISOString()
              .split("T")[0];
            return thoughtDate === today;
          }

          return false;
        });

        if (thoughtForToday) {
          setTodayThought(thoughtForToday);
        }
      } catch (error) {
        console.error("Failed to load today's thought", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTodaysThought();
  }, [sessionId]);

  // 🚫 Hide completely if no thought
  if (isLoading || !todayThought) return null;

  return (
    <div className="mb-6 bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-100 rounded-xl p-4 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="bg-blue-500 text-white rounded-full p-2">
          <i className="fas fa-lightbulb"></i>
        </div>
        <div>
          <h3 className="text-sm font-semibold text-gray-700 mb-1">
            Today’s Thought
          </h3>
          <p className="text-gray-600 text-sm italic">
            “{todayThought.thought || todayThought.message}”
          </p>
        </div>
      </div>
    </div>
  );
};

export default TodaysThought;
